import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import SelectInput from "../../components/form/SelectInput";
import FooterButton from "../../components/ui/Button/FooterButton";
import {
  INVOICE_PERIOD_FILE_NAME,
  useFetchInvoice,
} from "../../features/loans/hooks/useFetchInvoice";
import { allowDownloadInvoice } from "../../utils/loan";
import styles from "./AllPayment.module.css";

export const AllInvoice = ({ loan }) => {
  const { t } = useTranslation("myLoanInvoice");
  const [installmentId, setInstallmentId] = useState();

  const { data: invoicePeriodImageUrl, isFetching } = useFetchInvoice({
    loanId: loan?.loan_id,
    installmentId,
    enabled: !!installmentId,
  });

  async function handleDownloadInvoice() {
    // Check if running in LINE's LIFF browser
    const isLineBrowser = /Line/i.test(navigator.userAgent);

    if (isLineBrowser) {
      const pathAndQuery = window.location.pathname + window.location.search;
      const host = "auunjai.com"; // Development host
      const baseUrl = `https://${host}${pathAndQuery}?openExternalBrowser=1`;

      // Detect platform (iOS or Android)
      const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
      const isAndroid = /Android/i.test(navigator.userAgent);

      let externalUrl;

      if (isAndroid) {
        // Android: Use intent URL to open in Chrome
        externalUrl = `intent://${host}${pathAndQuery}#Intent;scheme=https;package=com.android.chrome;end`;
      } else if (isIOS) {
        // iOS: Show a prompt to the user to open in Safari
        const userConfirmed = window.confirm(
          "This page works better in Safari. Would you like to open it in Safari now?"
        );
        if (userConfirmed) {
          externalUrl = baseUrl;
        } else {
          // If user cancels, stay on the current page
          return;
        }
      } else {
        // Fallback for other platforms
        externalUrl = baseUrl;
      }

      // Perform the redirect
      window.location.href = externalUrl;
      return;
    }

    // Otherwise download normally
    const a = document.createElement("a");
    a.href = invoicePeriodImageUrl;
    a.download = `${INVOICE_PERIOD_FILE_NAME}-${loan?.loan_name}.pdf`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  const installmentOptions = useMemo(
    () =>
      loan?.installments
        ?.filter((installment) => allowDownloadInvoice(installment))
        ?.map((installment, i) => ({
          value: installment.installment_id,
          label: `งวด ${i + 1}`,
        })) || [],
    [loan?.installments]
  );

  return (
    <div className={styles.container}>
      <SelectInput
        isFormik={false}
        label=""
        placeholder={t("selectPeriod")}
        options={installmentOptions}
        onChange={(e) => setInstallmentId(e.target.value)}
        value={installmentId}
      />
      <FooterButton
        submitButtonTitle={t("downloadInvoice")}
        onSubmit={handleDownloadInvoice}
        disabledSubmit={!installmentId || isFetching}
      />
    </div>
  );
};
